module.exports = __webpack_public_path__ + "img/fdaab66.png";